import React, { useState } from 'react';
import { SFooterNav, NavItem } from '@/components/ui/organisms/SFooterNav';

const FooterNavDemo: React.FC = () => {
  const [activeItem, setActiveItem] = useState<NavItem>('home');

  const handleNavClick = (item: NavItem) => {
    console.log('Navigation clicked:', item);
    setActiveItem(item);
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: '#F5F5F5'
    }}>
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h1>Footer Navigation Demo</h1>
        <p>Active item: <strong>{activeItem}</strong></p>
        <p>Click on the navigation items below to test</p>
      </div>

      <div style={{ 
        position: 'fixed', 
        bottom: 0, 
        left: '50%', 
        transform: 'translateX(-50%)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <SFooterNav activeItem={activeItem} onItemClick={handleNavClick} />
      </div>
    </div>
  );
};

export default FooterNavDemo;
